module.exports = __webpack_public_path__ + "img/munka1.ca380b91.jpg";